import { useCallback, useRef } from 'react';

export function useOnClickOutside(onEscapeOutside: () => void) {
  const ref = useRef<Element>();
  const callbackRef = useRef<{
    onEscape: (e: KeyboardEvent) => void;
    onClick: (e: Event) => void;
  }>({
    onEscape: () => {},
    onClick: () => {},
  });
  const setRef = useCallback(
    (node) => {
      if (ref.current) {
        const { onEscape, onClick } = callbackRef.current;
        document.removeEventListener('keydown', onEscape);
        document.removeEventListener('click', onClick, true);
        document.removeEventListener('touchend', onClick, true);
      }
      callbackRef.current = {
        onEscape: (e: KeyboardEvent) => {
          if (e.keyCode === 27) onEscapeOutside();
        },
        onClick: (e: Event) => {
          if (!node.contains(e.target)) onEscapeOutside();
        },
      };
      if (node) {
        const { onEscape, onClick } = callbackRef.current;
        document.addEventListener('keydown', onEscape);
        document.addEventListener('click', onClick, true);
        document.addEventListener('touchend', onClick, true);
      }
      // Save a reference to the node
      ref.current = node;
    },
    [onEscapeOutside],
  );
  return [setRef];
}
